import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format decimal hours as `H:MM` (e.g. 1.75 → "1:45") */
export function fmtHours(hours: number): string {
  const h = Math.floor(hours)
  const m = Math.round((hours - h) * 60)
  return `${h}:${String(m).padStart(2, "0")}`
}

/** Uppercase the first character of a string. */
export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * Format an ISO date string (`YYYY-MM-DD`) as `Mon D, YYYY`; `null` → "—".
 * Anchored to local midnight so a date-only value doesn't shift across the
 * timezone boundary.
 */
export function formatDate(dateStr: string | null): string {
  if (!dateStr) return "—"
  return new Date(`${dateStr}T00:00:00`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  })
}

/** Format elapsed time since an ISO timestamp as `HH:MM:SS` */
export function fmtElapsedSince(startedAtIso: string, now: number = Date.now()): string {
  const startedAt = new Date(startedAtIso).getTime()
  const diff = Math.max(0, Math.floor((now - startedAt) / 1000))
  const h = Math.floor(diff / 3600)
  const m = Math.floor((diff % 3600) / 60)
  const s = diff % 60
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
}
